import { render, staticRenderFns } from "./ProModal.vue?vue&type=template&id=5c3d6c75&scoped=true"
import script from "./ProModal.vue?vue&type=script&lang=js"
export * from "./ProModal.vue?vue&type=script&lang=js"
import style0 from "./ProModal.vue?vue&type=style&index=0&id=5c3d6c75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3d6c75",
  null
  
)

export default component.exports